import { FieldType, WelcomeIntroPage } from '@bybeam/platform-types';
import { makeEduConfig } from './baseConfig.js';

const CONFIG = makeEduConfig();
const COHORT_YEAR = 'cohortYear';

// Add new question
const youAndYourSituationSection = CONFIG.sections.find(({ key }) => key === 'youAndYourSituation');
youAndYourSituationSection.questionGroups[0].questions.push({
  key: COHORT_YEAR,
  copy: { title: 'What is your cohort year?' },
  fields: [
    {
      type: FieldType.RadioList,
      key: COHORT_YEAR,
      options: [
        { label: 'Year 1 Cohort', value: 'year-1' },
        { label: 'Year 2 Cohort', value: 'year-2' },
        { label: 'Not Applicable', value: 'notapplicable' },
      ],
    },
  ],
});
// Make documentation optional
CONFIG.sections[CONFIG.sections.findIndex(({ key }) => key === 'documents')] =
  CONFIG.definitions.sections.optionalDocumentation;

// Update intro pages copy
(CONFIG.introPages[0] as WelcomeIntroPage).body = `
The Microgrant is available to DCPS Persists Alumni in their First and Second Year of the program.
These funds do not require repayment.

If you are in your Third year or above, please apply for the Emergency Fund program.
To learn more, go to [{FAQ_PAGE}]({FAQ_PAGE}).`;

// Update Student ID question copy
const personalInfoSection = CONFIG.sections.find(({ key }) => key === 'personalInfo');
personalInfoSection.questionGroups[0].questions[2].copy.title =
  'What is your DCPS High School Student ID?';

export default CONFIG;
